import useManagement, {
  selectors as managementSelectors,
} from 'publisher/hooks/useManagement'
import { typedPageSelectors, usePage as useTypedPage } from 'publisher/store'
import { useState } from 'react'
// import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  FormInterface,
  FormSubentityTypeEnum,
} from 'src/shared/types/entities/form-interface'
import { useFormContext } from '../context/form-context'
// TODO: uncomment it later
// import { validateEmptyOptInFields } from 'publisher/utils/fieldValidation'
// import { redirectTo } from 'publisher/utils/redirect'
// import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'

export interface UseOptInSubmitFormInterface {
  formEntity: FormInterface
}

// TODO: this is a draft
export const useOptInSubmitForm = ({
  formEntity,
}: UseOptInSubmitFormInterface) => {
  // const { t } = useTypedTranslation()
  const [isLoading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])
  const [isSuccess, setSuccess] = useState(false)

  const { fieldsValues, checkboxesValues } = useFormContext()
  const isTemplate = useTypedPage(typedPageSelectors.getIsPageTemplate)
  const isPreview = useManagement(managementSelectors.isPreviewMode)

  const onSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()

    setSuccess(false)

    if (!isTemplate && !isPreview) {
      const checkboxes = formEntity.subEntities.filter(
        subentity => subentity.type === FormSubentityTypeEnum.Checkbox,
      )

      const checkboxesErrors = checkboxes.reduce((errors, checkbox) => {
        return Object.entries(checkboxesValues).some(
          ([id, checked]) =>
            id === checkbox.id && !checked && !checkbox.optional,
        )
          ? errors
          : errors.concat(checkbox.errorText)
      }, [] as string[])

      if (checkboxesErrors.length > 0) {
        setErrors(checkboxesErrors)
      } else {
        /* TODO: add validation: adjust the validateEmptyOptInFields for array of fields
        const emptyFieldErrors = validateEmptyOptInFields(
          formEntity.subEntities.filter(
            subentity => subentity.type === FormSubentityTypeEnum.Field,
          ),
          t,
        )
        if (Object.keys(emptyFieldErrors).length) {
          setCommonErrors([])
          setFieldsErrors(emptyFieldErrors)
        } else {*/
        setLoading(true)
        try {
          /* TODO: add optIn api call
           const { data } = await optIn({
              fields: fieldsValues,
              doubleOptIn: formEntity.action.doubleOptIn,
            }) */
          /* TODO: add redirection 
          if (
            formEntity.action.redirectionType ===
              RedirectionTypesEnum.customUrl &&
            formEntity.action.urlRedirect
          ) {
            redirectTo(formEntity.action.urlRedirect)
          } else if (
            formEntity.action.redirectionType === RedirectionTypesEnum.nextStep && 
            data.redirect
          ) {
            redirectTo(data.redirect)
          }
          */

          // biome-ignore lint/suspicious/noConsole: <explanation>
          console.log('fieldsValues', fieldsValues)
          setSuccess(true)
        } catch (_error) {
          /* TODO: add error handling
            if (error instanceof exceptions.BadRequest) {
              setErrors(error.response.data.errors.common)
              dispatch(
                optInFail({
                  fields: error.response.data.errors.fields,
                }),
              )
              window.dispatchEvent(new Event('form_updated'))
            } else if (error instanceof exceptions.NetworkError) {
              setErrors([t('core.errors.no_connection')])
            } else if (error instanceof exceptions.NotFound) {
              setErrors([t('page Not Found')])
            } else {
              console.log(`--error--`, error)
              rollbar.error(`Form opt-in error`, error as Error)
            } 
              */
          setSuccess(false)
        }
        setLoading(false)
        // }
      }
    }
  }
  return { isLoading, errors, onSubmit, isSuccess }
}
